/**
 * Sprint 15 Ola 7 — AuriaIcon
 * Custom SVG icon for aurIA.
 * Props: variant ('default'|'listening'|'thinking'|'completed'), size (default 24)
 */

import React from 'react'

const styles = `
@keyframes auria-pulse-ring {
  0% { transform: scale(1); opacity: 0.8; }
  70% { transform: scale(1.4); opacity: 0; }
  100% { transform: scale(1.4); opacity: 0; }
}
@keyframes auria-dot-bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-4px); opacity: 1; }
}
.auria-icon-pulse-ring {
  animation: auria-pulse-ring 1.5s ease-out infinite;
  transform-origin: center;
}
.auria-icon-dot1 { animation: auria-dot-bounce 1.2s ease-in-out infinite; }
.auria-icon-dot2 { animation: auria-dot-bounce 1.2s ease-in-out 0.2s infinite; }
.auria-icon-dot3 { animation: auria-dot-bounce 1.2s ease-in-out 0.4s infinite; }
`

let stylesInjected = false
function injectStyles() {
  if (stylesInjected || typeof document === 'undefined') return
  const tag = document.createElement('style')
  tag.textContent = styles
  document.head.appendChild(tag)
  stylesInjected = true
}

export default function AuriaIcon({ variant = 'default', size = 24 }) {
  injectStyles()

  if (variant === 'listening') {
    return (
      <svg
        data-testid="auria-icon-listening"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="auria-icon-pulse-ring"
          cx="12"
          cy="12"
          r="10"
          stroke="var(--prime-terracota, #c0715a)"
          strokeWidth="1.5"
          fill="none"
        />
        <circle cx="12" cy="12" r="7" fill="var(--prime-terracota, #c0715a)" />
        <text
          x="12"
          y="16"
          textAnchor="middle"
          fontSize="9"
          fontWeight="700"
          fill="white"
          fontFamily="system-ui, sans-serif"
        >A</text>
      </svg>
    )
  }

  if (variant === 'thinking') {
    return (
      <svg
        data-testid="auria-icon-thinking"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="11" fill="var(--prime-terracota, #c0715a)" opacity="0.15" />
        <circle
          className="auria-icon-dot1"
          cx="8"
          cy="12"
          r="2"
          fill="var(--prime-terracota, #c0715a)"
        />
        <circle
          className="auria-icon-dot2"
          cx="12"
          cy="12"
          r="2"
          fill="var(--prime-terracota, #c0715a)"
        />
        <circle
          className="auria-icon-dot3"
          cx="16"
          cy="12"
          r="2"
          fill="var(--prime-terracota, #c0715a)"
        />
      </svg>
    )
  }

  if (variant === 'completed') {
    return (
      <svg
        data-testid="auria-icon-completed"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="11" fill="var(--prime-sage, #7d9e8c)" />
        <path
          d="M7.5 12.5 L10.5 15.5 L16.5 9"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  // default variant
  return (
    <svg
      data-testid="auria-icon-default"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="auria-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--prime-terracota, #c0715a)" />
          <stop offset="100%" stopColor="var(--prime-sage, #7d9e8c)" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="11" fill="url(#auria-grad)" />
      <text
        x="12"
        y="16.5"
        textAnchor="middle"
        fontSize="11"
        fontWeight="700"
        fill="white"
        fontFamily="system-ui, sans-serif"
      >A</text>
    </svg>
  )
}
